module.exports = __webpack_public_path__ + "static/media/preacher-street.4428fe1f.png";